import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import toast from 'react-hot-toast';

const schema = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  message: z.string().min(1),
});

const ContactForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = (data) => {
    console.log('Contact form:', data); // Integrate email here
    toast.success('Message sent');
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="bg-white p-6 rounded-lg shadow">
      <input {...register('name')} placeholder="Name" className="border p-2 mb-2 w-full" />
      {errors.name && <p className="text-red-500">{errors.name.message}</p>}
      <input {...register('email')} placeholder="Email" className="border p-2 mb-2 w-full" />
      {errors.email && <p className="text-red-500">{errors.email.message}</p>}
      <textarea {...register('message')} placeholder="Message" className="border p-2 mb-2 w-full" />
      {errors.message && <p className="text-red-500">{errors.message.message}</p>}
      <button type="submit" className="bg-primary-950 text-white px-4 py-2 rounded hover:bg-primary/90 w-full">Send</button> {/* Blue button */}
    </form>
  );
};

export default ContactForm;